import { LOAD_DATA_SUCCESS, LOAD_DATA_REQUEST } from '../actions';

const initialState = {};

function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_DATA_REQUEST:
      return { ...state, [action.payload.url]: { loading: true } };

    case LOAD_DATA_SUCCESS:
      return {
        ...state, [action.payload.url]: {
          loading: false,
          data: action.payload.data
        }
      };
    default:
      return state;
  }
}

export default reducer;
